module.exports = __webpack_public_path__ + "img/video-back.5707f92f.png";